

/**
 * @param {string} hash_trigger Hash string, that will be used to trigger open and close menu
 * @param {string} open_class Optional style class name when menu is opened, default 'menu-opened'
 * @param {string} close_class  Optional style class name when menu is closed, default menu-closed
 * */
class MenuOpenClose {

    constructor(hash_trigger, open_class = 'menu-opened', close_class = 'menu-closed') {
        this.hash_trigger = hash_trigger;
        this.open_class = open_class;
        this.close_class = close_class;
        this.init();
    }

    openMenu() {
        const body_classList = document.body.classList;
        body_classList.add(this.open_class);
        body_classList.remove(this.close_class);
    }

    closeMenu() {
        const body_classList = document.body.classList;
        body_classList.add(this.close_class);
        body_classList.remove(this.open_class);
    }


    hamClick() {
        if (location.hash.includes(this.hash_trigger)) {
            this.closeMenu();
            history.replaceState(null, null, ' ');
        }
        else {
            this.openMenu();
            location.hash = this.hash_trigger;
        }
    }

    hashTrigger(event) {

        if (event) event.preventDefault();

        if (location.hash.includes(this.hash_trigger))
            this.openMenu();
        else
            this.closeMenu();
    }

    init() {
        window.addEventListener("hashchange", event => this.hashTrigger(event));
        this.hashTrigger();
    }
}

const menu = new MenuOpenClose('open-menu');
